import React from 'react';
import { motion } from 'framer-motion';
import './CategoryCard.css';

const CategoryCard = ({ category, isActive, onClick }) => {
  return (
    <motion.div
      className={`category-card ${isActive ? 'active' : ''}`}
      onClick={onClick}
      whileHover={{ scale: 1.05, y: -5 }}
      whileTap={{ scale: 0.98 }}
      style={{
        '--category-color': category.color
      }}
    >
      <div className="card-glow" />
      {category.image && (
        <div className="card-image-wrapper">
          <img 
            src={category.image} 
            alt={category.title}
            className="card-image"
            loading="lazy"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        </div>
      )}
      <div className="card-content">
        <h3 className="card-title">{category.title}</h3>
        <p className="card-description">{category.description}</p>
        <div className="card-count">
          {category.products.length} товаров
        </div>
        <motion.div
          className="card-button"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          Посмотреть товары →
        </motion.div>
      </div>
    </motion.div>
  );
};

export default CategoryCard;

